<template>
  <div class="open-app">
    <!-- 로딩 상태 -->
    <div v-if="!showAppNotFound" class="loading-container">
      <p class="loading-text">앱을 여는 중입니다<span class="dots">...</span></p>
      <p class="loading-subtext">잠시만 기다려주세요.</p>
      
      <!-- 기존 GIF 이미지 또는 새로운 스피너 -->
      <div class="spinner-container">
        <div class="loading-spinner"></div>
      </div>
    
    </div>

    <!-- 앱을 찾을 수 없을 때 -->
    <div v-if="showAppNotFound && this.$isMobile" class="error-container">
      <p class="error-text">앱이 없다면?</p>
      <p class="error-subtext">{{isIOS ? '앱스토어':'Play 스토어'}}에서 ZIKOO앱을 다운로드하세요</p>
      
      <button class="store-button" @click="goToAppStore">
        <span>{{ isIOS ? 'App Store로 이동' : 'Play Store로 이동' }}</span>
      </button>

      <button class="web-button" @click="goToWeb">
        <span>웹으로 계속하기</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpenApp',
  data() {
    return {
      fallbackUrl: '',
      showSafariGuide: false,
      showAppNotFound: false,
      useGifLoader: true, // GIF를 사용할지 CSS 스피너를 사용할지
      isIOS: false,
      isAndroid: false,
      webUrl: '',
      storeUrl: '',
    };
  },
  created() {
    const encodedPath = this.$route.query.target;
    const userAgent = navigator.userAgent || navigator.vendor;
    this.isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    this.isAndroid = /android/i.test(userAgent);
    
    let decodedPath = decodeURIComponent(encodedPath) == 'undefined' ? undefined : decodeURIComponent(encodedPath);
    const fallbackUrl = `https://play.google.com/store/apps/details?id=com.zikooapp`;

    if (typeof decodedPath === 'string' && decodedPath.includes('&fbclid')) {
      decodedPath = decodedPath.split('&fbclid')[0];
    }

    let schemeUrl = decodedPath? `${process.env.VUE_APP_MAIN_URL}${decodedPath}`:`${process.env.VUE_APP_MAIN_URL}`;
    this.webUrl = schemeUrl;
    
    // 스토어 URL 설정
    this.storeUrl = this.isIOS 
      ? "https://apps.apple.com/app/id1531832957"
      : fallbackUrl;

    if (!this.isIOS && !this.isAndroid) {
      window.location.href = schemeUrl;
      return;
    }

    // 기존 로직 유지하되, 실패시 showAppNotFound를 true로 변경
    if (!decodedPath && this.isIOS) {
      window.location.href = `zikooapp://zikoo.co.kr/`;

      const timeout1 = setTimeout(() => {
        this.showAppNotFound = true;
      }, 1700);
      
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(timeout1);
        }
      });
      return;
    }
    
    if (!decodedPath && this.isAndroid) {
      window.location.href = `intent://zikoo.co.kr#Intent;scheme=https;package=com.zikooapp;S.browser_fallback_url=${fallbackUrl};end`;
      
      // Android도 실패 케이스 처리
      const timeout2 = setTimeout(() => {
        this.showAppNotFound = true;
      }, 2000);
      
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(timeout2);
        }
      });
      return;
    }
    
    if (!this.isIOS) {
      schemeUrl = `intent://zikoo.co.kr/${decodedPath}#Intent;scheme=https;package=com.zikooapp;S.browser_fallback_url=${process.env.VUE_APP_MAIN_URL}${decodedPath};end`;
      const timeout3 = setTimeout(() => {
        this.showAppNotFound = true;
      }, 2000);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(timeout3);
        }
      });
    } else {
      schemeUrl = `zikooapp://zikoo.co.kr/${decodedPath}`;
      const timeout4 = setTimeout(() => {
        this.showAppNotFound = true;
      }, 1700);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(timeout4);
        }
      });
    }

    window.location.href = schemeUrl;
  },
  methods: {
    goToAppStore() {
      window.location.href = this.storeUrl;
    },
    
    goToWeb() {
      window.location.href = this.webUrl;
    },

    /**
     * ✅ iOS: 앱 시도 → 실패시 앱스토어 이동 (웹 fallback까지 처리)
     */
    openAppOrStore(appUrl, storeUrl, webUrl) {
      window.location.href = appUrl;

      const timeout = setTimeout(() => {
        window.location.href = storeUrl || webUrl;
      }, 2000);

      // ✅ 앱 열리면 visibilitychange 이벤트로 타이머 해제
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(timeout);
        }
      });
    },
  },
};
</script>

<style scoped>
.open-app {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  padding: 20px;
}

.loading-container,
.error-container {
  text-align: center;
  max-width: 400px;
  width: 100%;
  padding: 40px 20px;
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}


.loading-text,
.error-text {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.loading-subtext,
.error-subtext {
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
}

.dots {
  animation: dots 1.5s steps(4, end) infinite;
}

@keyframes dots {
  0%, 20% { 
    color: transparent; 
    text-shadow: .25em 0 0 transparent, .5em 0 0 transparent; 
  }
  40% { 
    color: #333; 
    text-shadow: .25em 0 0 transparent, .5em 0 0 transparent; 
  }
  60% { 
    text-shadow: .25em 0 0 #333, .5em 0 0 transparent; 
  }
  80%, 100% { 
    text-shadow: .25em 0 0 #333, .5em 0 0 #333; 
  }
}

.spinner-container {
  margin: 30px 0;
}


.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #333;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.store-button,
.web-button {
  background: #333;
  border: none;
  color: white;
  padding: 15px 25px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 5px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: center;
}

.web-button {
  background: transparent;
  border: 2px solid #666;
  color: #666;
  padding: 13px 23px;
}
.store-button:hover,
.web-button:hover {
  opacity: 0.8;
}

.store-button:active,
.web-button:active {
  transform: scale(0.98);
}

.store-button span,
.web-button span {
  position: relative;
  z-index: 1;
}

@media (max-width: 480px) {
  .loading-container,
  .error-container {
    padding: 30px 15px;
  }
  
  .loading-text,
  .error-text {
    font-size: 20px;
  }
  
  .store-button,
  .web-button {
    font-size: 14px;
    min-width: 145px;
    display: block;
    margin: 9px auto;
  }
}
</style>